import { render } from "./TheEditor.vue?vue&type=template&id=2437849c&scoped=true&ts=true"
import script from "./TheEditor.vue?vue&type=script&lang=ts"
export * from "./TheEditor.vue?vue&type=script&lang=ts"

import "./TheEditor.vue?vue&type=style&index=0&id=2437849c&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2437849c"]])

export default __exports__